import { ethers } from 'ethers';
import currentAuthUser from "./currentAuthUser"
import { newSignedHash2 } from '../components/tools/GenerateSolutionRedeemer';

export default async function calculateSolutionRedeemer(pri: string) {
    const user: string = await currentAuthUser()
    const sig = await newSignedHash2(user, new ethers.Wallet(pri))
    return sig.flatSig
}